import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 指定した集計の推奨を一時的に非表示にするユースケース
 */
export class PutRecommendHiddenUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 指定した集計の推奨を一時的に非表示にする
   * @param aggregateBusinessIds - 非表示にする集計IDリスト
   * @param isHidden - 非表示にするかどうか
   */
  public async execute(aggregateBusinessIds: string[], isHidden: boolean): Promise<INetworkResult<void, IError>> {
    try {
      const response = await this.repository.putRecommendHidden(aggregateBusinessIds, isHidden);
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
